import { useUserStore } from "~/stores/userstore";
import { useCompanyStore } from "~/stores/companystore";
import { type ToastItem, useToastStore } from "~/stores/ui/toaststore";

export default defineNuxtRouteMiddleware(async (_unused_to, _unused_from) => {
  console.debug("userIsInApprovedDeveloperCompany middleware");
  const userStore = useUserStore();
  const companyStore = useCompanyStore();

  await companyStore.ensureLoaded();

  if (!companyStore.userCompany?.approvedContributor) {
    const toastStore = useToastStore();
    toastStore.addToast({
      id: self.crypto.randomUUID(),
      title: `Not in approved developer company`,
      body: `You are not in an approved developer company.`,
      appendToast: false,
      position: "top-center",
      variant: "warning",
      solid: true,
    } as ToastItem);
    return navigateTo(
      "/users/" +
        userStore.authUserUuid +
        "/company/" +
        companyStore.userCompany?.id +
        "/profile",
    );
  }
});
